module.exports = __webpack_public_path__ + "static/media/highfive.ae87e981.jpeg";